import { memo } from 'react';

function TaxDetails() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.8889 7.66677V6.11122C13.8889 5.25211 13.1924 4.55566 12.3333 4.55566H4.55556C3.69645 4.55566 3 5.25211 3 6.11122V10.7779C3 11.637 3.69645 12.3334 4.55556 12.3334H6.11111M7.66667 15.4446H15.4444C16.3036 15.4446 17 14.7481 17 13.889V9.22233C17 8.36322 16.3036 7.66677 15.4444 7.66677H7.66667C6.80756 7.66677 6.11111 8.36322 6.11111 9.22233V13.889C6.11111 14.7481 6.80756 15.4446 7.66667 15.4446ZM13.1111 11.5557C13.1111 12.4148 12.4147 13.1112 11.5556 13.1112C10.6964 13.1112 10 12.4148 10 11.5557C10 10.6966 10.6964 10.0001 11.5556 10.0001C12.4147 10.0001 13.1111 10.6966 13.1111 11.5557Z"
        stroke="#6B7280"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default memo(TaxDetails);
